import React, { useContext, useEffect, useState } from "react";
import { ethers } from "ethers";
import { ProjectContext } from "../../ProjectContext";
import { useAccount } from "wagmi";

function HistoryTable() {
  const { account, esigner, settings, DailReawardCap, dbuser, Maincontract, useractivestatus } = useContext(ProjectContext);
  const [Data, setData] = useState([]);
  const { isConnected } = useAccount();
  console.log("useractivestatus", useractivestatus);

  const getData = async () => {
    if (!isConnected || !settings.token || esigner === null || !settings.contract) return;

    const getUser = await Maincontract.getuserstakings(account);
    if (!getUser || getUser.length === 0) {
      setData([]);
      return;
    }

    const userData = getUser.map(item => ({
      address: item[1],
      amount: Number(ethers.utils.formatUnits(item[2], 18)).toFixed(0),
      dailyroi: ethers.utils.formatUnits(item[3], 18),
      dailyreward: Number(ethers.utils.formatUnits(item[4], 18)) + Number(DailReawardCap),
      levelreward: ethers.utils.formatUnits(item[6], 18),
      team: ethers.utils.formatUnits(item[6], 18),
      startdate: new Date(parseInt(item[7]._hex, 16) * 1000),
      enddate: new Date(parseInt(item[8]._hex, 16) * 1000),
      capdate: new Date(parseInt(item[9]._hex, 16) * 1000),
      status: parseInt(item[11].toString()),
    }));

    const sortedUserData = userData.sort((a, b) => b.startdate - a.startdate);
    setData(sortedUserData);
  };

  useEffect(() => {
    if (dbuser?.address.toLowerCase() === account.toLowerCase()) {
      getData();
    }
  }, [dbuser, account]);

  return (
    <div className="py-0" style={{ minHeight: "0px" }}>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title text-white">History</h4>
              <button className="text-white btn-outline-bg-new-primary py-2 px-3" onClick={getData}>
                <i className="fa fa-refresh"></i>
              </button>
            </div>
            <div className="card-body">
              <div className="table-responsive" style={{ height: "370px" }}>
                <table className="table table-responsive-md">
                  <thead>
                    <tr>
                      <th><strong>#</strong></th>
                      <th><strong>AMOUNT</strong></th>
                      <th><strong>DATE</strong></th>
                      <th><strong>STATUS</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data.length > 0 ? (
                      Data.map((user, index) => (
                        <tr key={index}>
                          <td><strong>{index + 1}</strong></td>
                          <td>$ {user.amount}</td>
                          <td>
                            Start: {user.startdate.toLocaleString()}<br />
                            End:
                            {user?.status === 1 ?
                              <>
                                {user.enddate.toLocaleString()}
                              </>
                              :
                              <>
                                {user.capdate.toLocaleString()}
                              </>
                            }
                          </td>
                          <td>
                            {index === 0 ? (
                              <span className={`badge light ${useractivestatus ? "badge-danger" : "badge-success"}`}>
                                {useractivestatus ? "Inactive" : "Active"}
                              </span>
                            ) : (
                              <span className={`badge light ${user?.status === 1 ? "badge-success" : "badge-danger"}`}>
                                {user?.status === 1 ? "Active" : "Inactive"}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryTable;
